import React, { useState } from "react";
import { useDesign } from '../../../context/contextDesign';
import { useProfile } from '../../../context/contextProfile';
import { useThemeMode } from '../../../context/contextTheme';

const BtnToggle = () => {
  const { theme } = useThemeMode();
  const { toggleSidebar } = useDesign();
  const { isSidebarExtended } = useProfile();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      className="navbar-toggle-btn d-flex justify-content-center align-items-center rounded-3"
      type="button"
      onClick={toggleSidebar}
      aria-controls="sidebarCollapse"
      aria-expanded={isSidebarExtended ? 'true' : 'false'}
      aria-label="Toggle Sidebar"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        fontSize: '24px',
        transition: 'all 0.3s ease',
        background: isHovered ? theme.background : theme.background2,
        border: isHovered ? `1px solid ${theme.borderHover}` : `1px solid ${theme.border}`,
        color: isHovered ? theme.textColor : theme.textMuted,
        boxShadow: isHovered ? '0 0 10px rgba(95, 62, 158, 0.25)' : 'none',
      }}>
      <i className="bi bi-list px-1"></i>
    </button>
  )
};

export default BtnToggle;